import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const STORAGE_KEY = "loadout-aim-callout-dismissed";
const DISMISS_DAYS = 30;

// Dismissible "mouse-shape shortlist" callout on the Mice PLP.
// Points to the Aim Theory 101 Operator Lab article. Hides for 30 days
// after the reader closes it (localStorage timestamp).
export default function AimTheoryCallout() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) {
        setVisible(true);
        return;
      }
      const ts = Number(raw);
      const age = Date.now() - ts;
      setVisible(!(Number.isFinite(ts) && age < DISMISS_DAYS * 24 * 60 * 60 * 1000));
    } catch {
      setVisible(true);
    }
  }, []);

  const dismiss = () => {
    setVisible(false);
    try {
      window.localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch { /* private mode etc. — session-only hide */ }
  };

  if (!visible) return null;

  return (
    <div
      data-testid="mice-aim-callout"
      className="relative mb-8 border border-[#FF9F1C]/40 bg-[#141414] px-5 py-5 md:px-6 md:py-6"
    >
      <button
        type="button"
        onClick={dismiss}
        aria-label="Dismiss"
        data-testid="mice-aim-callout-dismiss"
        className="absolute right-3 top-3 inline-flex h-8 w-8 items-center justify-center text-[#8A8A8A] hover:text-[#FF9F1C] transition-colors"
      >
        <X className="h-4 w-4" />
      </button>
      <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-[#FF9F1C]">
        New in the Lab
      </div>
      <p className="mt-2 font-display text-white text-[18px] md:text-[20px] leading-tight max-w-[52ch]">
        Aim Theory 101 — the mouse-shape shortlist, mapped to how you actually aim.
      </p>
      <p className="mt-2 font-sans text-[13px] text-[#8A8A8A] leading-relaxed max-w-[62ch]">
        Tracking, flicks, micro-corrections — plus the shapes, weights and hump
        placements the pros use for each. Find your archetype before you pick a shell.
      </p>
      <Link
        to="/operator-lab/aim-theory-101"
        data-testid="mice-aim-callout-link"
        className="mt-4 inline-block font-mono text-[11px] uppercase tracking-[0.16em] text-[#FF9F1C] hover:text-[#FBBF24] border-b border-[#FF9F1C] hover:border-[#FBBF24] pb-0.5 transition-colors"
      >
        Read the shape map →
      </Link>
    </div>
  );
}
